export const rowOnEachPage = {
  wishlistTable: 5,
  artistTable: 7,
};
